import { useContext } from "react";
import { WebContext } from "../Utility";

const useDeviceView = () => {
  const websiteContext = useContext(WebContext) || {};
  const { isMobile = false, deskTopView = true } = websiteContext;

  return { isMobile, deskTopView };
};

export default useDeviceView;
